/* Kindly category filter + sort (sections/kindly-category.liquid). Pure state in KindlyFilter.match/sortCards
   (unit-tested in v2/test/nav.test.js); the DOM part reads the card data-* attributes, keeps the state in the URL
   (?size=L%2FXL&print=sunny-days&cat=ankle&price=2000-3000&avail=1&sort=price-asc) and never reloads the page. */
(function () {
  var K = (window.KindlyFilter = window.KindlyFilter || {});
  var KEYS = ['cat', 'size', 'print', 'price', 'avail'];
  function list(s) { return (s || '').split(/[| ]/).filter(Boolean); }
  /* card: {cats, sizes, prints, price (cents), avail (bool)}; f: {cat:[], size:[], print:[], price:['0-2000'], avail:['1']}.
     OR inside a group, AND across groups. */
  K.match = function (card, f) {
    if (f.cat && f.cat.length && !f.cat.some(function (c) { return card.cats.indexOf(c) > -1; })) return false;
    if (f.size && f.size.length && !f.size.some(function (s) { return card.sizes.indexOf(s) > -1; })) return false;
    if (f.print && f.print.length && !f.print.some(function (p) { return card.prints.indexOf(p) > -1; })) return false;
    if (f.price && f.price.length && !f.price.some(function (r) { var a = r.split('-').map(Number); return card.price >= a[0] && card.price < a[1]; })) return false;
    if (f.avail && f.avail.length && !card.avail) return false;
    return true;
  };
  K.sortCards = function (cards, how) {
    var c = cards.slice();
    var by = {
      'price-asc': function (a, b) { return a.price - b.price || a.pos - b.pos; },
      'price-desc': function (a, b) { return b.price - a.price || a.pos - b.pos; },
      'new': function (a, b) { return b.date - a.date || a.pos - b.pos; },
      'az': function (a, b) { return a.title.localeCompare(b.title) || a.pos - b.pos; }
    }[how] || function (a, b) { return a.pos - b.pos; };
    return c.sort(by);
  };
  K.read = function (el) {
    var d = el.dataset;
    return { el: el, pos: +d.pos || 0, price: +d.price || 0, date: +d.date || 0, title: d.title || '',
      cats: list(d.cats), sizes: (d.sizes || '').split('|').filter(Boolean), prints: list(d.prints), avail: d.avail === '1' };
  };
  K.fromQuery = function (q) {
    var p = new URLSearchParams(q), f = {};
    KEYS.forEach(function (k) { f[k] = p.getAll(k); });
    f.sort = p.get('sort') || 'featured';
    return f;
  };
  K.toQuery = function (f) {
    var p = new URLSearchParams();
    KEYS.forEach(function (k) { (f[k] || []).forEach(function (v) { p.append(k, v); }); });
    if (f.sort && f.sort !== 'featured') p.set('sort', f.sort);
    var s = p.toString();
    return s ? '?' + s : '';
  };

  function init(root) {
    var grid = root.querySelector('[data-kf-grid]');
    if (!grid || root.__kf) return;
    root.__kf = true;
    var dlg = root.querySelector('[data-kf]'), form = root.querySelector('[data-kf-form]');
    var sortSel = root.querySelector('[data-kf-sort]'), pills = root.querySelector('[data-kf-pills]');
    var none = root.querySelector('[data-kf-none]'), badge = root.querySelector('[data-kf-active-n]');
    var cards = Array.prototype.map.call(grid.querySelectorAll('[data-kpc]'), K.read);
    var state = K.fromQuery(location.search);
    function syncForm() {
      if (!form) return;
      Array.prototype.forEach.call(form.querySelectorAll('input[type=checkbox]'), function (i) { i.checked = (state[i.name] || []).indexOf(i.value) > -1; });
      if (sortSel) sortSel.value = state.sort;
    }
    function readForm() {
      KEYS.forEach(function (k) { state[k] = []; });
      Array.prototype.forEach.call(form.querySelectorAll('input[type=checkbox]:checked'), function (i) { state[i.name].push(i.value); });
    }
    function labelFor(name, value) {
      var i = form && form.querySelector('input[name="' + name + '"][value="' + (window.CSS && CSS.escape ? CSS.escape(value) : value) + '"]');
      var s = i && i.parentNode.querySelector('span:last-child');
      return s ? s.textContent.trim() : value;
    }
    function apply(push) {
      var shown = 0;
      cards.forEach(function (c) { var ok = K.match(c, state); c.el.hidden = !ok; if (ok) shown++; });
      K.sortCards(cards, state.sort).forEach(function (c) { grid.appendChild(c.el); });
      Array.prototype.forEach.call(root.querySelectorAll('[data-kf-count]'), function (n) { n.textContent = shown; });
      Array.prototype.forEach.call(root.querySelectorAll('[data-kf-word]'), function (n) { n.textContent = shown === 1 ? 'style' : 'styles'; });
      if (none) none.hidden = shown > 0;
      var active = [];
      KEYS.forEach(function (k) { (state[k] || []).forEach(function (v) { active.push([k, v]); }); });
      if (badge) { badge.hidden = !active.length; badge.textContent = active.length ? ' (' + active.length + ')' : ''; }
      if (pills) {
        pills.innerHTML = '';
        active.forEach(function (a) {
          var b = document.createElement('button');
          b.type = 'button'; b.className = 'kcat__pill';
          b.setAttribute('aria-label', 'Remove filter ' + labelFor(a[0], a[1]));
          b.innerHTML = '<span></span><span aria-hidden="true">&times;</span>';
          b.firstChild.textContent = labelFor(a[0], a[1]);
          b.addEventListener('click', function () { state[a[0]] = state[a[0]].filter(function (v) { return v !== a[1]; }); syncForm(); apply(true); });
          pills.appendChild(b);
        });
        if (active.length > 1) {
          var c = document.createElement('button'); c.type = 'button'; c.className = 'kcat__pill kcat__pill--clear'; c.textContent = 'Clear all';
          c.addEventListener('click', clear); pills.appendChild(c);
        }
        pills.hidden = !active.length;
      }
      if (push) { try { history.replaceState(null, '', location.pathname + K.toQuery(state) + location.hash); } catch (e) {} }
    }
    function clear() { KEYS.forEach(function (k) { state[k] = []; }); syncForm(); apply(true); }
    if (form) form.addEventListener('change', function () { readForm(); apply(true); });
    if (sortSel) sortSel.addEventListener('change', function () { state.sort = sortSel.value; apply(true); });
    Array.prototype.forEach.call(root.querySelectorAll('[data-kf-clear]'), function (b) { b.addEventListener('click', clear); });
    var opener = root.querySelector('[data-kf-open]');
    function close() { if (dlg && dlg.open) dlg.close(); document.documentElement.classList.remove('kf-lock'); if (opener) opener.focus(); }
    if (opener && dlg) opener.addEventListener('click', function () {
      if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
      document.documentElement.classList.add('kf-lock');
    });
    Array.prototype.forEach.call(root.querySelectorAll('[data-kf-close]'), function (b) { b.addEventListener('click', close); });
    if (dlg) {
      dlg.addEventListener('click', function (e) { if (e.target === dlg) close(); });
      dlg.addEventListener('close', function () { document.documentElement.classList.remove('kf-lock'); });
    }
    syncForm();
    apply(false);
  }
  K.init = init;
  function boot() { Array.prototype.forEach.call(document.querySelectorAll('[data-kindly-category]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
